// Learn TypeScript:
//  - https://docs.cocos.com/creator/2.4/manual/en/scripting/typescript.html
// Learn Attribute:
//  - https://docs.cocos.com/creator/2.4/manual/en/scripting/reference/attributes.html
// Learn life-cycle callbacks:
//  - https://docs.cocos.com/creator/2.4/manual/en/scripting/life-cycle-callbacks.html

import BasePopUpLayer from "../../../../../engines/components/BasePopUpLayer";
import O1HD from "../../../../../engines/gameEngine";
import utilsModel from "../../../../../engines/libs/utilsModel";
import utilsView from "../../../../../engines/libs/utilsView";
import { GeneralKind } from "../../../../define/GeneralKind";
import { backPackEventMap } from "../../../config/BackpackEventConfig";
import NormalGameManager from "../../../manager/NormalGameManager";
import ModelDialogLayer from "../../../../gameCommon/basic/ModelDialogLayer";
import SettleLawsuitPrimaryHeadNode from "./SettleLawsuitPrimaryHeadNode";

const {ccclass, property} = cc._decorator;

/** 自己说话背景和文字位置差 */
const c_selfTalkSpaceY = 45;
@ccclass
export default class SettleLawsuitPrimarySelectSpecial extends BasePopUpLayer {

    @property({ type: cc.Label, displayName:'' })
	labelTalkHint: cc.Label = null;

    @property({ type: cc.Node, displayName:'' })
    sprHintDialog: cc.Node = null;

	@property({ type: cc.Node, displayName:'' })
	nodeHint: cc.Node = null;

	@property({ type: cc.Label, displayName:'' })
	labelPropHint2: cc.Label = null;

	@property({ type: cc.Label, displayName:'' })
	labelPropHint1: cc.Label = null;


    @property(cc.Node)
    nodeItemCharge: cc.Node = null;

    @property(cc.Node)
    nodeHead: cc.Node = null;

    @property(cc.Node)
    nodeSelectCharge: cc.Node = null;

    @property(cc.Label)
    labelPropNum: cc.Label = null;

    @property(cc.Toggle)
    propToggle: cc.Toggle = null;

    private propNum = 0;
    /** 最小高度 */
    private minTalkHeight = 0;

    // LIFE-CYCLE CALLBACKS:

    // onLoad () {}

    start () {
        this.nodeItemCharge.active = false;
        this.minTalkHeight = this.sprHintDialog.height;

        let headScript = cc.find('SettleLawsuitPrimaryHeadNode', this.nodeHead).getComponent(SettleLawsuitPrimaryHeadNode);
        headScript.setCarryData({
            id: this._carryData.peopleId
        });

        this.initLayer();
    }

    initLayer() {

        let big_offical_remind = this._carryData.csvInfo.big_offical_remind;
        this.nodeHint.active = false;
        if (utilsModel.isValidNumberValue(big_offical_remind)) {
            this.nodeHint.active = true;
            this.labelTalkHint.string = big_offical_remind;
            utilsView.refreshLabelUI(this.labelTalkHint);

            let height = this.labelTalkHint.node.height;
            height = Math.max(height + c_selfTalkSpaceY, this.minTalkHeight);
            this.sprHintDialog.height = height;
            this.labelTalkHint.node.getComponent(cc.Widget).updateAlignment();
        }

        this.initPropInfo();
        let selectArr = this._carryData.selectArr;
        for (let o of selectArr) {
            let nodeItem = cc.instantiate(this.nodeItemCharge);
            nodeItem.active = true;

            let toggle = cc.find('toggle', nodeItem).getComponent(cc.Toggle);
            toggle.check();
            toggle.interactable = false;
            let label = cc.find('labelName', nodeItem).getComponent(cc.Label);
            label.string = o;

            this.nodeSelectCharge.addChild(nodeItem);
        }
    }

    initPropInfo() {
        let goodsId = GeneralKind.PropId.THE_MEDALLION_ID;
        let itemConfig = backPackEventMap()[goodsId];
        // this.labelPropName.string = itemConfig.name;

        this.labelPropHint2.string = `(${itemConfig.name}剩余×`
        this.labelPropHint1.string = '使用' + itemConfig.name;

        let propData = NormalGameManager._instance.getGameData().backpack[goodsId];
        let num = this.propNum = propData && propData.num || 0;
        this.labelPropNum.string = "" + num;

        this.labelPropNum.node.color = num > 0 
            ? new cc.Color(0x65, 0xB0, 0x34) 
            : new cc.Color(0xB8, 0x28, 0x20); 
        if (num > 0) {
            this.propToggle.check();
        } else {
            this.propToggle.uncheck();
        }
    }

    onClickReset(event: cc.Event.EventTouch, data) {
        O1HD.getManagers().soundMgr.playSound("anNiu").then();
        this.destroyNode();
        this._carryData.parent.anewStartSelect();
    }

    onClickForce() {
        this.destroyNode();
        O1HD.getManagers().soundMgr.playSound("anNiu").then();

        if (this.propToggle.isChecked) {
            let goodsId = GeneralKind.PropId.THE_MEDALLION_ID;
            NormalGameManager._instance.onOutGoods(goodsId);
            
            let bSuccess = this._carryData.bSuccess;
            let retArr = this._carryData.retArr;
            this._carryData.parent.showResultUI(bSuccess, retArr);
        } else {
            let retArr = this._carryData.loseArr;
            this._carryData.parent.showResultUI(false, retArr);
        }
    }

    onClickClose() {
        O1HD.getManagers().soundMgr.playSound("anNiu").then();
        ModelDialogLayer.show('确定退出衙门吗？', null, ()=> {
            this.destroyNode();
            this._carryData.parent.closeLayer();
        });
    }

    onClickToggle(toggle: cc.Toggle, data) {
        O1HD.getManagers().soundMgr.playSound("anNiu").then();
        if (toggle.isChecked && this.propNum <= 0) {
            toggle.uncheck();
            O1HD.getModules().uiControlModule.showMessageBox(
                "道具数量不足"
                , null
                , 2
                , 150
            );
            return;
        }
    }

    // update (dt) {}
}
